import { render, staticRenderFns } from "./pendingDocumentCardHeader.vue?vue&type=template&id=665d9734&scoped=true&"
import script from "./pendingDocumentCardHeader.vue?vue&type=script&lang=js&"
export * from "./pendingDocumentCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./pendingDocumentCardHeader.vue?vue&type=style&index=0&id=665d9734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d9734",
  null
  
)

export default component.exports